<template>
  <v-card class="ml-4 mt-2">
    <v-toolbar color="primary">
      <v-toolbar-title class="white--text">{{dataToDisplay.title}}</v-toolbar-title>
    </v-toolbar>
    <v-list subheader>
        <div v-for="line in dataToDisplay.lines" :key="line.title">
          <v-list-tile v-if="line.value" avatar>
            <v-list-tile-avatar></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ line.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout row>
                <v-flex>
                  <v-btn color="primary" icon>{{ line.value }}</v-btn>
                </v-flex>
                <!--
                <v-flex class="ml-4">
                  <span>{{(Math.round(Math.random() * 100) / 100).toFixed(2)}} / 1</span>
                </v-flex>
                -->
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset v-if="line.value"></v-divider>
        </div>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    dataToDisplay: {
      required: true,
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>
